const civilAdministrationSupervision = {
  path: '/civilAdministrationSupervision', // 主体
  name: 'civilAdministrationSupervision',
  redirect: '/workbench',
  component: () => import('../views/civilAdministrationSupervision/main'), 
  children: [
    {
      path: '/workbench',
      name: 'workbench',
      meta: { 
        title: '工作台'
      },
      component: () => import ('../views/civilAdministrationSupervision/workbench/index.vue'),
    }, {
		path: '/trainingplan',
		name: 'trainingplan',
		meta: {
		  title: '培训计划'
		},
		component: () => import ('../views/civilAdministrationSupervision/trainingplan/index.vue'),
	  },
	{
	  path: '/rectificationRecord',
	  name: 'rectificationRecord',
	  meta: {
	    title: '整改记录'
	  },
	  component: () => import ('../views/civilAdministrationSupervision/rectificationRecord/index.vue'),
	},
	{
		path: '/StarManagement',
		name: 'StarManagement',
		meta: {
		  title: '星级管理'
		},
		component: () => import ('../views/civilAdministrationSupervision/StarManagement/index.vue'),
	},
	{
		path: '/CreditManagement',
		name: 'CreditManagement',
		meta: {
		  title: '表彰管理'
		},
		component: () => import ('../views/civilAdministrationSupervision/CreditManagement/index.vue'),
	},
	{
	  path: '/informationResources',
	  name: 'informationResources',
	  redirect: '/occupancyRate',
	  meta: {
	    title: '信息资源'
	  },
	  component: () => import ('../views/civilAdministrationSupervision/informationResources/index.vue'),
	  children: [
		{
		  path: '/occupancyRate',
		  name: 'occupancyRate',
		  meta: {
		    title: '入住率'
		  },
		  component: () => import ('../views/civilAdministrationSupervision/informationResources/occupancyRate.vue'),
		},{
		  path: '/institutionalBeds',
		  name: 'institutionalBeds',
		  meta: {
		    title: '机构床位'
		  },
		  component: () => import ('../views/civilAdministrationSupervision/informationResources/institutionalBeds.vue'),
		},{
		  path: '/InstitutionalStaff',
		  name: 'InstitutionalStaff',
		  meta: {
		    title: '机构员工'
		  },
		  component: () => import ('../views/civilAdministrationSupervision/informationResources/InstitutionalStaff.vue'),
		},{
		  path: '/StatisticsOfOperationSubsidies',
		  name: 'StatisticsOfOperationSubsidies',
		  meta: {
		    title: '运营补贴发放统计'
		  },
		  component: () => import ('../views/civilAdministrationSupervision/informationResources/StatisticsOfOperationSubsidies.vue'),
		},{
			path: '/civiFile',
			name: 'civiFile',
			redirect: '/civilAffairsDocuments',
			meta: {
			  title: '民政文件' 
			},
	   	component: () => import ('../views/civilAdministrationSupervision/informationResources/civiFile/index.vue'),
		 children: [
			{
				path: '/civilAffairsDocuments',
				name: 'civilAffairsDocuments',
				meta: {
					title: '民政文件'
				},
				component: () => import ('../views/civilAdministrationSupervision/informationResources/civiFile/civilAffairsDocuments.vue'),
	    	},{
				path: '/SubsidiesAnnounce',
				name: 'SubsidiesAnnounce',
				meta: {
					title: '补贴公告'
				},
				component: () => import ('../views/civilAdministrationSupervision/informationResources/civiFile/SubsidiesAnnounce.vue'),
	    	}
	      ]
		},
	  ]
	},{
      path: '/healthAssessmen',
      name: 'healthAssessmen',
      meta: {
        title: '健康评估'
      },
      component: () => import ('../views/civilAdministrationSupervision/healthAssessmen/index.vue'),
    },{
	  path: '/SubsidyManagement',
	  name: 'SubsidyManagement',
	  meta: {
	    title: '补贴管理'
	  },
	  component: () => import ('../views/civilAdministrationSupervision/SubsidyManagement/index.vue'),
	  children: [
		  {
		    path: '/SubsidyAllocation',
		    name: 'SubsidyAllocation',
		    meta: {
		      title: '补贴配置'
		    },
		    component: () => import ('../views/civilAdministrationSupervision/SubsidyManagement/SubsidyAllocation/index.vue'),
		     children: [
				 {
				   path: '/operationSubsidySetting',
				   name: 'operationSubsidySetting',
				   meta: {
				     title: '运营补贴设置'
				   },
				   component: () => import ('../views/civilAdministrationSupervision/SubsidyManagement/SubsidyAllocation/operationSubsidySetting.vue'),
				 },{
				   path: '/Establishment',
				   name: 'Establishment',
				   meta: {
				     title: '护理员补贴设置'
				   },
				   component: () => import ('../views/civilAdministrationSupervision/SubsidyManagement/SubsidyAllocation/Establishment.vue'),
				 },{
				   path: '/EstablishmentOfConstructionSubsidy',
				   name: 'EstablishmentOfConstructionSubsidy',
				   meta: {
				     title: '建设补贴设置'
				   },
				   component: () => import ('../views/civilAdministrationSupervision/SubsidyManagement/SubsidyAllocation/EstablishmentOfConstructionSubsidy.vue'),
				 },{
				   path: '/SubsidyForBedOperation',
				   name: 'SubsidyForBedOperation',
				   meta: {
				     title: '床位运营补贴设置'
				   },
				   component: () => import ('../views/civilAdministrationSupervision/SubsidyManagement/SubsidyAllocation/SubsidyForBedOperation.vue'),
				 }
			 ]
		  },{
		    path: '/SubsidyAudit',
		    name: 'SubsidyAudit',
		    meta: {
		      title: '补贴审核'
		    },
		    component: () => import ('../views/civilAdministrationSupervision/SubsidyManagement/SubsidyAudit/index.vue'),
		     children: [
				{
				  path: '/OperationSubsidySudit',
				  name: 'OperationSubsidySudit',
				  meta: {
				    title: '运营补贴审核'
				  },
				  component: () => import ('../views/civilAdministrationSupervision/SubsidyManagement/SubsidyAudit/OperationSubsidySudit.vue'),
				},{
				  path: '/AuditOfoperatingSubsidyForNurses',
				  name: 'AuditOfoperatingSubsidyForNurses',
				  meta: {
				    title: '护理员补贴审核'
				  },
				  component: () => import ('../views/civilAdministrationSupervision/SubsidyManagement/SubsidyAudit/AuditOfoperatingSubsidyForNurses.vue'),
				},{
				  path: '/ConstructionAndOperationSubsidyAudit',
				  name: 'ConstructionAndOperationSubsidyAudit',
				  meta: {
				    title: '建设补贴审核'
				  },
				  component: () => import ('../views/civilAdministrationSupervision/SubsidyManagement/SubsidyAudit/ConstructionAndOperationSubsidyAudit.vue'),
				},{
				  path: '/AuditOfBedOperationSubsidy',
				  name: 'AuditOfBedOperationSubsidy',
				  meta: {
				    title: '床位运营补贴审核'
				  },
				  component: () => import ('../views/civilAdministrationSupervision/SubsidyManagement/SubsidyAudit/AuditOfBedOperationSubsidy.vue'),
				},
			 ],
		  }
	  ]
	},{
	  path: '/organizationEstablishment',
	  name: 'organizationEstablishment',
	  meta: {
	    title: '机构设立审批'
	  },
	  component: () => import ('../views/civilAdministrationSupervision/organizationEstablishment/index.vue'),
	},
  ]
}
export default civilAdministrationSupervision